import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Clipboard } from '@angular/cdk/clipboard';
import { UserInfoService } from 'src/app/services/user-info.service';
import { CouponGenerateComponent } from '../../shared/common/coupon-generate/coupon-generate.component';
import { ShareCampaignComponent } from '../../shared/common/share-campaign/share-campaign.component';
import { ResourceService } from 'src/app/services/common/resource.service';
import { Meta } from '@angular/platform-browser';
import { CampaignsService } from 'src/app/services/campaigns.service';
import { AlertService } from 'src/app/services/common/alert.service';
import { GlobalService } from 'src/app/services/common/global.service';
import { GlobalVariables } from 'global-variables.dev';
import { StorageService } from 'src/app/services/common/storage.service';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { Theme, ThemeService } from 'src/app/services/theme.service';
import { UserService } from 'src/app/services/user.service';
import { WishListService } from 'src/app/services/wishlist.service';

@Component({
  selector: 'app-deals-details',
  templateUrl: './deals-details.component.html',
  styleUrls: ['./deals-details.component.scss']
})
export class DealsDetailsComponent implements OnInit {
  dealBackgroundColor = 'white';
  private subs = new Subscription();

  queryString = Object();
  campaignID: any = "";
  ID: any = "";
  organizationId!: string;
  slug!: string;
  displayedImages: string[] = [];
  matchingProducts: any;
  selectedProductId: string | null = null;
  campaignData: any;
  isTermsExpanded = false;
  moment = moment;

  couponColor: any;
  campaignName: any;
  offerDescription: any = "";
  couponTypeName: any;
  offerType: any;
  applicableOn: any = "";
  offerTypeTitle: any;
  offerTypeTitle2: any;
  freeProductTitle: any;
  endDate: any;
  location: any;
  couponCode: any;
  ccySymbol: any = '';
  validDays: any = '';
  url = "";
  qrCodeImage = "";
  qrCodeValue = "";
  locationMatch: boolean = true;
  invalidPrivateCampaign = false
  company_logo: any
  discount: any;
  savePrice: any = 0;

  buyGetProductBox: any = [];
  buyGetFreeProductBox: any = [];

  days: any;
  hours: any;
  minutes: any;
  seconds: any;
  myInterval: any;
  popup!: boolean;
  resource: any = {};
  stores: any[] = [];

  encodeQrCodeValue = "";
  noOfCoupons!: number;
  campaignImages: string[] = [];
  isLoggedIn = false;
  discountOffer!: number;
  constructor(private activatedRoute: ActivatedRoute,
    private userInfoService: UserInfoService,
    private wishListService: WishListService,
    public dialog: MatDialog,
    private router: Router,
    private clipboard: Clipboard,
    private globalService: GlobalService,
    private alertService: AlertService,
    private resourceService: ResourceService,
    private campaignsService: CampaignsService,
    private storageService: StorageService,
    private themeService: ThemeService,
    private userService: UserService,

  ) {
    this.activatedRoute.data.subscribe(({ data }) => {
      if (data?.data) {
        this.organizationId = data.data;
        this.slug = activatedRoute.snapshot.paramMap.get('slug')!;

      }
    })
  }

  async ngOnInit() {
    this.isLoggedIn = this.userInfoService.getLoginFlag();
    this.loadResoruce();
    this.resourceService.languageSubject.subscribe(response => {
      this.resource = response;
    });
    this.queryString = this.activatedRoute.snapshot.queryParams;
    this.campaignID = this.queryString.campaign ? this.queryString.campaign : "";

    if (this.queryString?.organizationId || this.organizationId) {
      this.ID = this.queryString.organizationId || this.organizationId;
      this.userService.detail(this.ID).subscribe({
        next: (res) => {
          let u = (res && res.data) ? res.data : res;
          this.company_logo = u.company_logo
          console.log('company_logo', this.company_logo)
        }
      })
    }



    if (this.queryString?.storeId)
      this.ID = this.queryString.storeId;

    this.url = this.router.url;

    this.activatedRoute.queryParams.subscribe(params => {
      this.popup = params.popup
    });

    this.activatedRoute.data.subscribe(({ campaign }) => {
      console.log("campaign.data", campaign.data)
      this.getCampaignDetail(campaign.data);
      console.log('campaign.data', campaign.data)
      this.getStoresList();
    })
    this.storageService.storageSubject.subscribe(response => {
      this.matchUserLocation()
    });
    this.matchUserLocation()

    this.subs.add(
      this.themeService.theme$.subscribe((t: Theme) => {
        this.dealBackgroundColor = (t === 'light') ? 'white' : 'black';
      })
    );

  }

  onProductClick(product: any) {
    this.selectedProductId = product._id;
    this.displayedImages = product.productImages.map(
      (img: any) => img.src
    );
  }


  matchUserLocation() {
    let searchData = this.storageService.getGlobalSearch();
    if (searchData.countryId) {
      if (searchData.countryId == this.campaignData.countryId) {
        this.locationMatch = true;
        if (this.campaignData.stateId != "" && searchData?.stateId && searchData?.stateId == this.campaignData.stateId) {
          this.locationMatch = true;
          if (this.campaignData.cityId != "" && searchData?.cityId && searchData?.cityId == this.campaignData.cityId) {
            this.locationMatch = true;
          }
          else
            this.locationMatch = false;
        }
      }
      else
        this.locationMatch = false;
    }
    else {
      this.locationMatch = false;
    }
  }

  loadResoruce() {
    this.resourceService.loadResoruce().subscribe(
      response => {
        this.resource = response;
      });
  }

  onClickWishList(row: any) {
    if (this.isLoggedIn) {
      var data = {
        campaignId: row.campaignId,
        isActive: !row.isWishList,
      }
      this.wishListService.add(data).subscribe(async (response: any) => {
        if (response.success) {
          if (row.isWishList) {
            this.alertService.showSuccess(row.campaignName + " " + this.resource.wishlist_remove);
          }
          else {
            this.alertService.showSuccess(row.campaignName + " " + this.resource.wishlist_add);
          }
          this.campaignData.forEach(element => {
            if (element.campaignId == row.campaignId) {
              element.isWishList = !row.isWishList
            }
          });
        }

        else {
          this.alertService.showError(response.message);
        }
      });
    }
    else {
      var campaignData = {
        campaignId: row.campaignId,
        campaignName: row.campaignName,
      }

      var url = "deal?wishlist=" + btoa(JSON.stringify(campaignData))
      this.router.navigate(['login'], { queryParams: { returnUrl: url } });
    }
  }

  onAddToCart(row: any) {

  }
  getStoresList() {
    navigator.geolocation.getCurrentPosition((result) => {
      let coordinates: { lat: number, long: number, ownerId?: string } = { lat: result.coords.latitude, long: result.coords.longitude };
      if (this.queryString.storeId) coordinates.ownerId = this.queryString.storeId;

      this.campaignsService.storeList(this.campaignID, coordinates)
        .subscribe(res => {
          if (res.success && Array.isArray(res.data)) {

            this.stores = [];

            this.stores = res.data.map((store: any, index: number) => ({
              ...store,
              displayIndex: index + 1
            }));
          }
        });
      // this.campaignsService.storeList(this.campaignID, coordinates).subscribe(res => {
      //   if (res.success) this.stores = res.data;
      // });
    })
  }

  trackByStore(index: number, store: any): string {
    return store._id || store.ownerId || index;
  }

  getCampaignDetail(campaign) {
    var data = campaign;
    this.noOfCoupons = data.numberofCoupons - data.claimCount
    this.matchingProducts = data.matchingProducts;
    if (data && data.status == "ACCEPTED") {
      this.campaignData = data;
      console.log("campaignData..", this.campaignData)
    }
    if (data && data.status == "PUBLISHED") {
      // if (data.campaignImage) {
      //   data.productDetails = [{ src: data.campaignImage }];
      // } else 
      if (data.products && Array.isArray(data.products)) {
        data.productDetails = data.products.reduce((acc: any[], curr: any) => {
          const matchedProduct = data.matchingProducts?.find((el: any) => el._id === curr.id);
          if (matchedProduct) acc.push(matchedProduct);
          return acc;
        }, []);
      } else {
        data.productDetails = [];
      }

      if (data.freeProducts) {
        data.freeProductDetails = data.freeProducts.reduce((acc: any, curr: any) => {
          const matchedProduct = data.matchingProducts.find((el: any) => el._id == curr.id);
          if (matchedProduct) acc.push(matchedProduct)
          return acc;
        }, [])
      }
      else
        data.freeProductDetails = [];

      this.campaignData = data;
      if (this.campaignData.campaignImageType == 'Campaign') this.campaignImages.push(this.campaignData.campaignImage)
      else if (this.campaignData.campaignImageType == 'BrandCampaign') this.campaignImages.push(this.campaignData.brandCampaignImage)
      else if (this.campaignData.campaignImage) this.campaignImages.push(this.campaignData.campaignImage)
      this.campaignData.productDetails.forEach(el => {
        el.productImages.forEach(el => this.campaignImages.push(el.src))
      })
      this.myInterval = setInterval(() => {
        var [hours = 0, minutes = 0, seconds = 0] = data.endTime?.split(":").map(Number);
        const endDate = new Date(data.endDate);
        if (data.endTime) {
          endDate.setHours(hours);
          endDate.setMinutes(minutes);
          endDate.setSeconds(seconds);
        }
        this.commingSoonTime(endDate);
      }, 1000);

      this.offerType = data.offerType;
      this.ccySymbol = data.currencySymbol;

      let location: any;
      if (data.country) {
        location = data.country;
      }
      if (data.state) {
        location = location + ", " + data.state;
      }
      if (data.city) {
        location = location + ", " + data.city;
      }

      this.location = location;

      this.freeProductTitle = "";

      this.couponTypeName = data.couponTypeName;

      if (data.offerType) {
        let discount = 0;
        let minAmount = 0;

        if (Array.isArray(data?.invoiceAmountSlab) && data.invoiceAmountSlab.length) {
          const lastSlab = data.invoiceAmountSlab[data.invoiceAmountSlab.length - 1];

          if (this.offerType === 'FLAT') {
            discount = Number(lastSlab?.discountAmount ?? lastSlab?.discount ?? 0);
          }

          if (this.offerType === 'DISCOUNT') {
            discount = Number(lastSlab?.discountPercentage ?? lastSlab?.discount ?? 0);
          }

          minAmount = Number(lastSlab?.minAmount ?? 0);
        }

        // this.discountOffer = discount;
        // let discount = Number(data?.invoiceAmountSlab[ data?.invoiceAmountSlab.length-1]?.discount) || 0
        // let minAmount = Number(data?.invoiceAmountSlab[ data?.invoiceAmountSlab.length-1]?.minAmount) || 0
        this.discountOffer = discount;
        if (this.offerType == "BUYGET") {
          this.offerTypeTitle = "Buy " + data.mainProductCount + " Get " + data.freeProductCount;
          this.freeProductTitle = "Free Item/s " + data.freeProductCount;
        }
        else if (this.offerType == "FLAT" && data.applicableOn !== 'INVOICE') {
          this.offerTypeTitle = "Flat discount" + this.ccySymbol + data.couponValue + " Off";
          this.discount = this.ccySymbol + this.formateNumber(data.couponValue, true);

          this.savePrice = Number(data.regularPrice) - Number(data.couponValue);
        }
        else if (this.offerType == "FLAT" && data.applicableOn == 'INVOICE') {
          this.applicableOn = 'INVOICE'
          this.offerTypeTitle = "Flat discount up to " + this.ccySymbol + discount + " Off";
          this.offerTypeTitle2 = "Flat discount up to " + this.ccySymbol + discount + " on a minimum purchase of " + this.ccySymbol + " " + minAmount;
          this.discount = this.ccySymbol + this.formateNumber(discount, true);

          this.savePrice = Number(data.regularPrice) - Number(discount);
        }
        else if (this.offerType == "FREESAM") {
          this.offerTypeTitle = data.offerTypeName;
          this.discount = this.formateNumber(data.regularPrice, true);

          this.savePrice = 0;
        }
        else if (this.offerType == "GIFTVC") {
          this.offerTypeTitle = data.offerTypeName + ' ' + this.ccySymbol + data.couponValue;
          this.discount = this.ccySymbol + this.formateNumber(data.couponValue, true);

          this.savePrice = Number(data.regularPrice) - Number(data.couponValue);
        }
        else if (this.offerType == "DISCOUNT" && data.applicableOn !== 'INVOICE') {

          this.offerTypeTitle = "Discount " + data.couponValue + "%" + " off";
          this.discount = this.formateNumber(data.couponValue, true) + "%";
          this.savePrice = (Number(data.regularPrice) * (Number(data.couponValue) / 100));
        }
        else if (this.offerType == "DISCOUNT" && data.applicableOn == 'INVOICE') {
          this.applicableOn = 'INVOICE'
          this.offerTypeTitle = "Discount up to " + discount + "%" + " Off";
          this.offerTypeTitle2 = "upto " + discount + "% off";
          this.discount = this.formateNumber(discount, true) + "%";
          this.savePrice = (Number(data.regularPrice) * (Number(discount) / 100));
        }
        else {
          this.offerTypeTitle = data.offerTypeName;
        }

      }
      this.couponColor = data.couponColor;
      this.campaignName = data.campaignName;
      this.offerDescription = data.offerDescription;
      this.endDate = data.endDate;
      this.couponCode = data.couponCode;
      this.validDays = data.validDays;

      if (this.offerType == "BUYGET") {
        data.productDetails?.forEach((product: any, i: number) => {
          product.productImages.forEach(el => {
            this.buyGetProductBox.push({
              number: i + 1,
              image: el.src ?? 'assets/img/no-image.png',
              //  title: product.name
            });
          })
          if (this.buyGetProductBox.length === 0)
            this.buyGetProductBox.push({
              number: i + 1,
              image: 'assets/img/no-image.png',
              // title: product.name
            });
        });
        data.freeProductDetails?.forEach((product: any, i: number) => {
          product.productImages.forEach(el => {
            this.buyGetFreeProductBox.push({
              number: i + 1,
              image: el.src ?? 'assets/img/no-image.png',
              //  title: product.name
            });
          })
          if (this.buyGetFreeProductBox.length === 0)
            this.buyGetFreeProductBox.push({
              number: i + 1,
              image: 'assets/img/no-image.png',
              // title: product.name
            });
        });
      }

      if (!this.campaignData.isPrivate)
        this.getCampaignQrCode();

      let isLoggedIn = this.userInfoService.getLoginFlag();
      if (isLoggedIn && this.campaignData.isPrivate) {
        this.onClickClaimNow();
      }

    }
    if (this.campaignData.campaignImageType == 'Campaign') this.campaignImages.push(this.campaignData.campaignImage)
    else if (this.campaignData.campaignImageType == 'BrandCampaign') this.campaignImages.push(this.campaignData.brandCampaignImage)
    else if (this.campaignData.campaignImage) this.campaignImages.push(this.campaignData.campaignImage)
    this.campaignData.productDetails.forEach(el => {
      el.productImages.forEach(el => this.campaignImages.push(el.src))
    })

    // Initialize with 0th product
    if (this.matchingProducts && this.matchingProducts.length > 0) {
      const firstProduct = this.matchingProducts[0];
      this.onProductClick(firstProduct);
    }

  }

  onClickClaimNow() {
    const loginRequired = this.campaignData.signInRequired;
    let isLoggedIn = this.userInfoService.getLoginFlag();
    if (isLoggedIn) {
      let dialogRef = this.dialog.open(CouponGenerateComponent, {
        disableClose: true,
        // width: '40%',
        data: {
          campaignId: this.campaignData._id,
          isGuest: false
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        this.invalidPrivateCampaign = result.showError && this.campaignData.isPrivate;
      });
    }
    else if (!loginRequired) {
      let dialogRef = this.dialog.open(CouponGenerateComponent, {
        disableClose: true,
        // width: '40%',
        data: {
          campaignId: this.campaignData._id,
          discount: this.discountOffer,
          isGuest: true
        }
      });
      dialogRef.afterClosed().subscribe(result => {
      });
    }
    else {
      var url = "deal/details?campaign=" + this.campaignData._id;
      if (this.ID) {
        if (this.organizationId) 
          url = this.slug + "details?campaign=" + this.campaignData._id;
        if (this.queryString?.organizationId)
          url = "deal/details?campaign=" + this.campaignData._id + "&organizationId=" + this.ID;
        if (this.queryString?.storeId)
          url = "deal/details?campaign=" + this.campaignData._id + "&storeId=" + this.ID;
      }
      this.router.navigate(['login'], { queryParams: { returnUrl: url } });
    }
  }

  onClickShareCampaign() {
    let dialogRef = this.dialog.open(ShareCampaignComponent, {
      disableClose: true,
      // width: '40%',
      data: {
        title: this.campaignData.campaignName,
        campaignId: this.campaignData._id,
        campaignName: this.campaignData.campaignName,
        offerDescription: this.campaignData.offerDescription,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  onClickBacktoDeal() {
    if (this.queryString?.returnURL)
      this.router.navigateByUrl(this.queryString?.returnURL);
    else if (this.queryString?.organizationId || this.organizationId)
      this.backToBrandDeals();
    else if (this.queryString?.storeId)
      this.backToStoreDeals(this.ID);
    else
      this.router.navigate(['deal']);
  }

  backToBrandDeals() {
    const base: any = { tab: 'promotions' };
    if (this.organizationId)
      this.router.navigate([this.slug], {queryParams: base});
    else if (this.ID)
      this.router.navigate(['deal/organization'], { queryParams: { organizationId: this.ID, ...base } });
    else
      this.router.navigate(['deal/organization'], { queryParams: { organizationId: this.campaignData.createdBy, ...base } });
  }

  backToStoreDeals(id: string) {
    this.router.navigate(['deal/store'], { queryParams: { storeId: id } });
  }

  pageTitle = [
    {
      bgImage: `assets/img/page-title/page-title4.jpg`,
      title: `The Start Hotel, Casino`,
    }
  ]

  commingSoonTime = (endDate: any) => {
    const endTimeParse = (Date.parse(endDate)) / 1000;
    const now = new Date();
    const nowParse = (Date.parse(now.toString()) / 1000);
    const timeLeft = endTimeParse - nowParse;
    const days = Math.floor(timeLeft / 86400);
    let hours = Math.floor((timeLeft - (days * 86400)) / 3600);
    let minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600)) / 60);
    let seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));
    if (hours < 10) { hours = 0 + hours; }
    if (minutes < 10) { minutes = 0 + minutes; }
    if (seconds < 10) { seconds = 0 + seconds; }
    this.days = days;
    this.hours = hours;
    this.minutes = minutes;
    this.seconds = seconds;
    if (this.days < 0) {
      this.campaignData.status = 'Expired';
      clearInterval(this.myInterval);
      this.days = 0; this.hours = 0; this.minutes = 0; this.seconds = 0;
    }
  }

  dealsDetailsImageSlides: OwlOptions = {
    items: 1,
    nav: true,
    loop: true,
    dots: false,
    autoplay: true,
    responsive: {
      0: {
        items: 1, // Mobile
      },
      768: {
        items: 1 // Tablet
      },
      1024: {
        items: 1 // Desktop
      }
    },
    animateIn: 'fadeIn',
    animateOut: 'fadeOut',
    autoplayHoverPause: true,
    navText: [
      "<i class='bx bx-left-arrow-alt'></i>",
      "<i class='bx bx-right-arrow-alt'></i>"
    ]
  }

  formateNumber(n: any, decimal: boolean = true) {
    let parts = (+n).toFixed(2).split(".");
    let num = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (+parts[1] ? "." + parts[1] : decimal ? ".00" : "");
    return num;
  }

  getCampaignQrCode() {
    this.campaignsService.qrCode(this.campaignID).subscribe((response: any) => {
      if (response.success) {
        this.qrCodeImage = response.data.qrCodeURL;
        this.qrCodeValue = response.data.qrCodeValue;

        let url = GlobalVariables.couponShareURL;

        this.qrCodeValue = url + "campaigns/" + this.campaignID;
        this.encodeQrCodeValue = encodeURIComponent(this.qrCodeValue);
      }
    })
  }

  onClickCopyURL() {
    this.clipboard.copy(this.qrCodeValue);
    this.alertService.showSuccess(this.resource.url_copied)
  }

  onClickDownloadQrCode() {
    // converts base 64 encoded image to blobData
    let blobData = this.globalService.convertBase64ToBlob(this.qrCodeImage);

    const blob = new Blob([blobData], { type: "image/png" });
    const url = window.URL.createObjectURL(blob);
    // window.open(url);
    const link = document.createElement('a');
    link.href = url;
    link.download = this.campaignName;
    link.click();
  }

  toggleTerms() {
    this.isTermsExpanded = !this.isTermsExpanded;
  }
  getSortedBuyOn(buyOnList: any[]) {
    if (!buyOnList) return [];
    return [...buyOnList].sort((a, b) => {
      const aPriority = a.buyOnName?.toLowerCase() === 'shopify' ? 0 : 1;
      const bPriority = b.buyOnName?.toLowerCase() === 'shopify' ? 0 : 1;
      return aPriority - bPriority;
    });
  }
  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  onThemeChanged(theme: Theme) {
    this.dealBackgroundColor = theme === 'light' ? 'white' : 'black';
  }
}